import React, { useEffect, useState } from "react";
import { Divider, FormHelperText, FormLabel, Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../../../components/Common/Breadcrumb';
import Notification from '../../../../components/Common/Notification';
import RadioButtonGroup from "../../../../components/Form/RadioButtonGroup";

import { connect, useDispatch } from 'react-redux';
import CustomTextField from "../../../../components/Form/CustomTextField";
import CustomSelect from "../../../../components/Form/CustomSelect";
import CustomButton from "../../../../components/Form/CustomButton";
import FormEditors from "../../../Forms/FormEditors";
import { createService, getServiceDetails, resetServiceState, updateService } from "../../../../store/actions";
import LoadingDialog from "../../../../components/Common/LoadingDialog";
import moment from "moment";



const AddService = ({ type, title, serviceDetails, addService, editService, formError, serviceTypeList }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { ID, module } = useParams();

    useEffect(() => {
        dispatch(resetServiceState());
        if (ID && type === 'Edit') {
            dispatch(getServiceDetails({ id: ID }));
        }
    }, []);

    const defaultValues = {
        service_name: "",
        service_type: "",
        description: "",
        status: "1",
        is_parent: "1",
    }
    const [values, setFormValues] = useState(defaultValues);
    const [serviceTypeName, setServiceTypeName] = useState('');
    const [loading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const data = [
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" },
    ]

    const dataCat = [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
    ]

    useEffect(() => {
        if (serviceTypeList && !serviceTypeName) {
            let name = serviceTypeList.filter((x) => parseInt(x.id) === parseInt(module));
            name = name?.length > 0 ? name[0].name : '';
            setServiceTypeName(name);
        }
    }, [serviceTypeList])

    useEffect(() => {
        if (serviceDetails) {
            let serviceData = serviceDetails?.service_type_descriptions;
            if (serviceData?.length > 0) {
                setFormValues({
                    service_name: serviceData[0].name || '',
                    service_type: serviceData[0].service_type_id || '',
                    description: serviceData[0].descriptions || '',
                    status: serviceDetails.status,
                    is_parent: serviceDetails.is_parent,
                    category_name: serviceDetails.category_name || '',
                })
            }
        }
    }, [serviceDetails])

    useEffect(() => {
        if (addService?.code === 'success') {
            setNotification({
                open: true,
                msg: 'Service added successfully',
                type: 'success'
            })
            navigate(`/settings-view-product-services/${module}`)
        }
        setIsLoading(false);
    }, [addService])

    useEffect(() => {
        if (editService?.code === 'success') {
            setNotification({
                open: true,
                msg: 'Service edited successfully',
                type: 'success'
            })
            navigate(`/settings-view-product-services/${module}`)
        }
        setIsLoading(false);
    }, [editService])

    useEffect(() => {
        if (formError?.length > 0) {
            setError(formError[0]);
        } else {
            setError('');
        }
        setIsLoading(false);
    }, [formError])

    const handleSubmit = () => {
        let payload = {
            name: values?.service_name || '',
            service_id: module,
            descriptions: values?.description || '',
            category_name: values?.category_name || '',
            status: values?.status || '',
            is_parent: values?.is_parent || ''
        }
        if (type === "Add") {
            dispatch(createService(payload));
            setIsLoading(true);
        }
        else if (type === "Edit") {
            dispatch(updateService({ id: ID, data: payload }));
        }

    }
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <LoadingDialog open={loading || (type === 'EDIT' && !serviceDetails?.service_type_descriptions)} />
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumbs
                        backRoute={`/settings-view-product-services/${module || ''}`}
                        breadcrumbItems={[{ title: serviceTypeName, link: `/settings-view-product-services/${module}` },
                        { title: title, link: "#" },
                        ]}
                    >
                        <CustomButton
                            title={type === 'Add' ? 'Save' : 'Save Changes'}
                            press={() => handleSubmit(type)}
                            height={40}
                            backgroundColor={'#101010'}
                            textColor={'white'}
                        />
                    </Breadcrumbs>
                    {/* <Card className="p-3">
                        <CardBody> */}
                    <Grid container spacing={2}>
                        <Grid item sm={12} lg={8} >
                            <Card className="p-3 px-2">
                                <CardBody>
                                    <div className="setting-header">BASIC INFO</div>
                                    <Divider className="my-2 mb-4" />
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <CustomTextField
                                                title={'Service name'}
                                                values={values?.service_name}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    service_name: e
                                                }))}
                                                placeholder="e.g. Premier Support"
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.name || ""}</FormHelperText>}
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <CustomTextField
                                                title={'Category Name'}
                                                values={values?.category_name}
                                                onChange={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    category_name: e
                                                }))}
                                                error={error?.category_name}
                                                placeholder="e.g. Category Name"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <FormEditors
                                                title={'Description'}
                                                value={values?.description || ''}
                                                setValue={(e) => {
                                                    setFormValues((prevValues) => ({
                                                        ...prevValues,
                                                        description: e
                                                    }))
                                                }}
                                            />
                                            {error && <FormHelperText sx={{ color: "red" }}>{error.descriptions || ""}</FormHelperText>}
                                        </Grid>
                                    </Grid>
                                </CardBody>
                            </Card>
                        </Grid>
                        <Grid container item sm={12} lg={type === 'add' ? 12 : 4}>
                            <Grid item xs={12} sm={12}>
                                <Card className="p-3 px-2">
                                    <CardBody>
                                        <div className="setting-header">SETTINGS</div>
                                        <Divider className="my-2 mb-4" />

                                        <div className="mt-3">
                                            <RadioButtonGroup
                                                title={'Status'}
                                                value={values.status}
                                                data={data}
                                                setValue={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    status: e,
                                                }))}
                                                name="status"
                                                error={error && error?.status}
                                            />
                                            <RadioButtonGroup
                                                title={'Is Main Category?'}
                                                value={values.is_parent}
                                                data={dataCat}
                                                setValue={(e) => setFormValues((prevValues) => ({
                                                    ...prevValues,
                                                    is_parent: e,
                                                }))}
                                                name="is_parent"
                                                error={error && error?.is_parent}
                                            />
                                        </div>


                                        {
                                            type === 'Edit' && serviceDetails?.updated_at &&
                                            <>
                                                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>Last modified</FormLabel>
                                                <div>{moment(serviceDetails?.updated_at).format("DD MMM YYYY")}, {moment(serviceDetails?.updated_at).format("hh:mm A")}</div>
                                            </>
                                        }
                                    </CardBody>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Service, General }) {
    return {
        serviceDetails: Service.serviceDetails.data,
        addService: Service.addService,
        editService: Service.updateService,
        formError: Service.error,
        serviceTypeList: General.services
    };
}

export default connect(mapStateToProps)(AddService);
